import parse, { PhoneNumber } from 'libphonenumber-js';

export function parsePhoneNumber(phoneNumber: string | undefined | null, addPlus: boolean = true): PhoneNumber | undefined {
  if (phoneNumber === undefined || phoneNumber === null) return undefined;
  const readyPhoneNumber = addPlus && phoneNumber[0] !== '+' ? `+${phoneNumber}` : phoneNumber;
  return parse(readyPhoneNumber);
}
